const Accounts = {
  getEntries:()=>'store/transactions',
  getGeneralAccountList:()=>'store/account',
}

export default Accounts
